import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { BankOutlined } from '@ant-design/icons';
import { Skeleton } from 'antd';
import './style.css';

export const Card = ({ value, label, icon, loading }) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  
  const integerLength = value ? value.toString().replace(/\D/g, '').length : 0;
  
  const shouldApplyClass = windowWidth > 1260 && windowWidth < 1441 && integerLength > 10;

  const shouldApplyDifferentClass = integerLength >= 14;

  return (
    <div>
      <div>
        {loading ? (
          <div className='Skeleton'>
            <Skeleton.Input active />
          </div>
        ) : (
          <div className="flex card-part">
            <div>{icon}</div>
            <div className="value-field">
              <p className='value-label'>{label}</p>
              <span className={`value-number ${shouldApplyClass ? 'large-value' : ''} ${shouldApplyDifferentClass ? 'different-class' : ''}`}>{value}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

Card.propTypes = {
  value: PropTypes.any,
  label: PropTypes.string.isRequired,
  icon: PropTypes.any.isRequired,
  loading: PropTypes.bool,
};

Card.defaultProps = {
  value: 'Card Value',
  label: 'Card Label',
  icon: <BankOutlined />,
  loading: false,
};

export default Card;
